import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"
import ShowroomMake from '../components/ShowroomMake.vue'
import svgIco from '../components/svgIco.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
        let make = this.el.dataset.make;
        const app = createApp({
            template: '<ShowroomMake make="' + make + '" />',
            components: {
                ShowroomMake,
                svgIco
            },
            data() {
                return {
                    spriteURL: self.el.dataset.sprite
                }
            }
        });
        app.component("svgIco", svgIco)
        app.config.globalProperties.cash = (value) => {
            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' $';
        }
        app.config.globalProperties.cents = (val) => {
            return parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',') + ' $';
        }
        app.mount(self.el)
        
    }
}
